export default __webpack_public_path__ + "static/media/backArrow.b706036e.svg";